import { Link } from 'react-router-dom'
import BrandLogo from '../components/BrandLogo'

/**
 * Landing page for an OAuth callback whose account was created but isn't
 * allowlisted (`/:orgSlug/oauth/pending`) — the account exists, isActive is
 * false, and an admin needs to approve it on the Users page.
 */
export default function OAuthPending() {
  return (
    <div className="min-h-screen app-sky flex items-center justify-center px-4">
      <div className="w-full max-w-md mx-auto text-center">
        <BrandLogo size={64} src="/icon-256.png" className="mx-auto rounded-2xl mb-6" />
        <h1 className="text-2xl font-bold text-harbor-text">Awaiting approval</h1>
        <p className="text-harbor-text-secondary mt-3">
          Your account was created, but it needs an admin to approve it before you can sign in.
          Check back once you've been notified, or reach out to your ContextHarbor admin.
        </p>
        <Link
          to="/login"
          className="inline-block mt-8 px-5 py-2.5 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors"
        >
          Back to sign in
        </Link>
      </div>
    </div>
  )
}
